export type LimitReachedDetail = {
  metric: 'messages' | 'chatbots' | 'team_members' | 'teams' | string
  used?: number
  limit?: number
  plan_name?: string
}

export const LIMIT_EVENT = 'bgai:limit_reached'

export function emitLimitReached(detail: LimitReachedDetail) {
  try {
    const evt = new CustomEvent(LIMIT_EVENT, { detail })
    window.dispatchEvent(evt)
  } catch {}
}

